<template>
  <div class="container my-5">
    <div class="vld-parent">
      <loading
        :active.sync="loading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="false"
        :height="25"
        :width="25"
      ></loading>
      <div class="title-container">
        <div>
          <h3 class="title">سفارش دهید</h3>
        </div>
        <div v-if="categories.length > 0" class="filters mt-5">
          <span
            class="filter"
            v-bind:class="{ active: currentFilter === 0 }"
            v-on:click="setFilter(0)"
          >همه</span>

          <span
            class="filter"
            v-bind:class="{ active: currentFilter === category.id }"
            v-on:click="setFilter(category.id)"
            v-for="category in categories"
            v-bind:key="category.id"
          >{{category.title}}</span>
        </div>
      </div>

      <transition-group class="row products" name="products" tag="div">
        <div
          class="col-lg-3 col-md-4 col-sm-6 product"
          v-for="(product , index) in productsFiltered"
          v-bind:key="index"
        >
          <products-component :product="product"></products-component>
        </div>
        <div class="section" v-if="products.length === 0">
          <p>{{ noProductLabel }}</p>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<style lang="scss" scoped>


.title-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.filters {
  text-align: center;
}

.filter {
  display: inline-block;
  font-size: 1.1rem;
  text-align: center;
  padding: 0.5rem 1rem;
  min-width: 10rem;
  cursor: pointer;
  transition: all 0.35s;
  border-bottom: 2px solid #00000026;
}

.filter.active,
filter:hover {
  border-color: #ef394f;
  box-shadow: 0px 1px 3px 0px #00000026;
}

.products {
  transition: all 0.25s ease-in-out;
  margin-bottom: 50px;
  margin-top: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.products-enter {
  transform: scale(0.5) translatey(-80px);
  opacity: 0;
}

.products-leave-to {
  transform: translatey(30px);
  opacity: 0;
}

.products-leave-active {
  position: absolute;
  z-index: -1;
}

.product {
  transition: all 0.2s ease-in-out;
}
</style>>

<script>
import { fetchAll } from "@/api/products";
import ProductsComponent from "@/views/products_list/ProductItem";

export default {
  components: {
    "products-component": ProductsComponent,
  },

   metaInfo:{
     title:"محصولات",
      //meta: [{ name: "description", content: "My page meta description" }],
   },

  mounted() {
    this.fetchAllProducts();
  },
  data() {
    return {
      loading: false,
      noProductLabel: "محصولی یافت نشد!",
      currentFilter: 0,
      products: [],
    };
  },

  computed: {
    productsFiltered: function () {
      return this.products.filter((product) => {
        if (this.currentFilter === 0) {
          return true;
        }

        let included = false;
        product.categories.map((category) => {
          if (this.currentFilter === category.id) {
            included = true;
          }
        });

        return included;
      });
    },
    categories: function () {
      let categories = [];
      this.products.map((product, i) => {
        if (product.categories) {
          product.categories.map((category, j) => {
            categories.push({
              id: category.id,
              title: category.title,
            });
          });
        }
      });

      categories = [
        ...new Map(categories.map((item) => [item["id"], item])).values(),
      ];

      return categories;
    },
  },

  methods: {
    setFilter: function (filter) {
      this.currentFilter = filter;
    },

    fetchAllProducts() {
      this.loading = true;
      fetchAll()
        .then(({ data }) => {
          this.loading = false;
          this.products = data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },

    onCancel() {},
  },
};
</script>